<template lang="pug">
.insc
  //- ============ HERO ============
  header.insc__hero
    .insc__hero-grid
    .insc__hero-glow.insc__hero-glow--blue
    .insc__hero-glow.insc__hero-glow--red
    .insc__hero-inner
      p.insc__eyebrow
        span.insc__eyebrow-pip
        | Inscrições
      h1.insc__title Inscrição de robôs
      p.insc__lead Selecione os robôs que vão disputar este evento.

      .insc__event(v-if="getCurrentEvent")
        span.insc__event-chip
          FontAwesomeIcon.insc__event-ic(:icon="['fas', 'trophy']")
          | {{ getCurrentEvent.name }}

      .insc__stats(v-if="getCurrentEventId && canManage")
        .insc__stat
          strong.insc__stat-num {{ enrolledIds.length }}
          span.insc__stat-lbl inscrito(s)
        .insc__stat
          strong.insc__stat-num {{ allRobots.length }}
          span.insc__stat-lbl robô(s) no total
        .insc__stat.insc__stat--accent(v-if="pendingCount")
          strong.insc__stat-num {{ pendingCount }}
          span.insc__stat-lbl a inscrever

  .insc__wrap
    //- ---------- ESTADOS ----------
    .insc__state(v-if="!getCurrentEventId")
      span.insc__state-ic
        FontAwesomeIcon(:icon="['fas', 'calendar-day']")
      .insc__state-txt
        strong Nenhum evento selecionado
        span Escolha um evento no seletor do topo para gerenciar as inscrições.

    .insc__state.insc__state--deny(v-else-if="!canManage")
      span.insc__state-ic
        FontAwesomeIcon(:icon="['fas', 'lock']")
      .insc__state-txt
        strong Acesso restrito
        span Você não tem permissão para gerenciar as inscrições deste evento.

    template(v-else)
      .insc__state(v-if="!categoriesWithRobots.length")
        span.insc__state-ic
          FontAwesomeIcon(:icon="['fas', 'robot']")
        .insc__state-txt
          strong Nenhum robô cadastrado
          span Cadastre robôs no perfil para poder inscrevê-los no evento.

      section.insc__cat(
        v-for="cat in categoriesWithRobots"
        :key="cat.id"
      )
        h2.insc__cat-title
          | {{ cat.name }}
          span.insc__cat-count {{ cat.robots.length }}
        .insc__grid
          label.rbtcard(
            v-for="r in cat.robots"
            :key="r.id"
            :class="{ 'rbtcard--on': selected.includes(r.id), 'rbtcard--in': isEnrolled(r.id) }"
          )
            input.rbtcard__input(
              type="checkbox"
              :value="r.id"
              v-model="selected"
              :disabled="isEnrolled(r.id)"
            )
            span.rbtcard__check
              FontAwesomeIcon(:icon="['fas', 'check']")
            span.rbtcard__body
              span.rbtcard__name {{ r.name }}
              span.rbtcard__team(v-if="r.team_name") {{ r.team_name }}
            span.rbtcard__badge(v-if="isEnrolled(r.id)")
              FontAwesomeIcon.rbtcard__badge-ic(:icon="['fas', 'circle-check']")
              | inscrito

  //- ---------- BARRA DE AÇÃO ----------
  .insc__bar(v-if="getCurrentEventId && canManage && categoriesWithRobots.length")
    .insc__bar-inner
      .insc__bar-info
        span.insc__bar-feedback.insc__bar-feedback--err(v-if="error")
          FontAwesomeIcon(:icon="['fas', 'triangle-exclamation']")
          | {{ error }}
        span.insc__bar-feedback.insc__bar-feedback--ok(v-else-if="success")
          FontAwesomeIcon(:icon="['fas', 'circle-check']")
          | Inscrições atualizadas!
        span.insc__bar-feedback(v-else)
          strong {{ pendingCount }}
          |  robô(s) selecionado(s) para inscrição
      button.insc__cta(:disabled="!pendingCount" @click="doRegister")
        | Inscrever selecionados
        FontAwesomeIcon.insc__cta-ic(:icon="['fas', 'arrow-right']")
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

export default {
  name: 'Inscricoes',
  data: () => ({
    allRobots: [],
    enrolledIds: [],
    selected: [],
    error: '',
    success: false
  }),
  created () {
    this.setCategories()
    this.load()
  },
  computed: {
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('events', [
      'getCurrentEvent',
      'getCurrentEventId'
    ]),
    ...mapGetters('categories', [
      'getCategories'
    ]),
    canManage () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && (roles.includes(1) || roles.includes(6))
    },
    pendingCount () {
      return this.selected.filter(id => !this.enrolledIds.includes(id)).length
    },
    categoriesWithRobots () {
      return [...this.getCategories]
        .map(c => ({
          id: c.id,
          name: c.name,
          robots: this.allRobots.filter(r => r.category_id === c.id)
        }))
        .filter(c => c.robots.length)
    }
  },
  methods: {
    ...mapActions('categories', [
      'setCategories'
    ]),
    ...mapActions('robots', [
      'fetchRobotsList',
      'setRegisterEventRobots'
    ]),
    isEnrolled (id) {
      return this.enrolledIds.includes(id)
    },
    load () {
      if (!this.getCurrentEventId) return
      this.fetchRobotsList().then(list => {
        this.allRobots = Array.isArray(list) ? list : []
      })
      this.fetchRobotsList({ event_id: this.getCurrentEventId }).then(list => {
        this.enrolledIds = Array.isArray(list) ? list.map(r => r.id) : []
      })
    },
    doRegister () {
      this.error = ''
      this.success = false
      const toEnroll = this.selected.filter(id => !this.enrolledIds.includes(id))
      if (!toEnroll.length) {
        this.error = 'Selecione ao menos um robô ainda não inscrito.'
        return
      }
      this.setRegisterEventRobots({
        owner: this.getUser.id,
        event_id: this.getCurrentEventId,
        robot_ids: toEnroll
      }).then(response => {
        if (response && response.length) {
          this.success = true
          this.selected = []
          this.load()
        } else {
          this.error = 'Não foi possível inscrever os robôs (sem permissão ou já inscritos).'
        }
      })
    }
  },
  watch: {
    getCurrentEventId () {
      this.selected = []
      this.load()
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$ink: #0B0E14
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$paper: #FFFFFF
$page: #F2F4F8
$green: #2E7D32

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.insc
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)

  *
    box-sizing: border-box

  // ---------- HERO ----------
  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 40px 0 52px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -160px
      left: -90px
    &--red
      background: $red
      bottom: -190px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 960px
    margin: 0 auto
    padding: 0 24px
    > *
      animation: insc-rise .6s cubic-bezier(.2, .7, .2, 1) both
    .insc__title
      animation-delay: .08s
    .insc__lead
      animation-delay: .12s
    .insc__event
      animation-delay: .16s
    .insc__stats
      animation-delay: .22s

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 18px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__title
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(30px, 4.4vw, 48px)
    line-height: 0.98
    letter-spacing: -0.015em
    margin: 0

  &__lead
    margin: 14px 0 0
    color: rgba(255, 255, 255, 0.74)
    font-size: 15px
    max-width: 46ch

  &__event
    margin: 22px 0 0

  &__event-chip
    display: inline-flex
    align-items: center
    gap: 9px
    font-family: $mono
    font-size: 12px
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.06em
    color: #fff
    background: rgba(40, 122, 237, 0.18)
    border: 1px solid rgba(40, 122, 237, 0.4)
    border-radius: 999px
    padding: 7px 15px

  &__event-ic
    color: #FFC857
    font-size: 13px

  &__stats
    display: flex
    flex-wrap: wrap
    gap: 12px
    margin: 24px 0 0

  &__stat
    display: flex
    flex-direction: column
    gap: 2px
    min-width: 104px
    padding: 14px 18px
    background: rgba(255, 255, 255, 0.06)
    border: 1px solid rgba(255, 255, 255, 0.12)
    border-radius: 14px
    &--accent
      background: rgba(40, 122, 237, 0.16)
      border-color: rgba(40, 122, 237, 0.42)

  &__stat-num
    font-family: $display
    font-weight: 800
    font-size: 30px
    line-height: 1

  &__stat-lbl
    font-family: $mono
    font-size: 10px
    text-transform: uppercase
    letter-spacing: 0.08em
    color: rgba(255, 255, 255, 0.66)

  // ---------- CORPO ----------
  &__wrap
    max-width: 960px
    margin: 0 auto
    padding: 40px 24px 120px

  // ---------- ESTADOS ----------
  &__state
    display: flex
    align-items: center
    gap: 18px
    padding: 22px 24px
    background: $paper
    border: 1px solid $line
    border-radius: 16px
    &--deny .insc__state-ic
      color: $red
      background: rgba(221, 52, 52, 0.10)
    &-ic
      display: grid
      place-items: center
      flex-shrink: 0
      width: 52px
      height: 52px
      border-radius: 12px
      font-size: 22px
      color: $blue
      background: rgba(40, 122, 237, 0.10)
    &-txt
      display: flex
      flex-direction: column
      gap: 4px
      strong
        font-family: $display
        text-transform: uppercase
        font-size: 19px
        font-weight: 700
        color: $ink
      span
        font-size: 14px
        color: $muted

  // ---------- CATEGORIAS ----------
  &__cat
    margin-top: 36px
    &:first-of-type
      margin-top: 0

  &__cat-title
    display: flex
    align-items: center
    gap: 12px
    font-family: $display
    text-transform: uppercase
    letter-spacing: 0.01em
    font-size: 22px
    font-weight: 700
    margin: 0 0 18px
    &::before
      content: ''
      width: 4px
      height: 20px
      border-radius: 2px
      background: linear-gradient(180deg, $blue, $red)

  &__cat-count
    font-family: $mono
    font-size: 12px
    font-weight: 700
    color: $muted
    background: rgba(11, 14, 20, 0.06)
    border-radius: 999px
    padding: 2px 10px

  &__grid
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 260px), 1fr))
    gap: 12px

  // ---------- BARRA DE AÇÃO ----------
  &__bar
    position: sticky
    bottom: 0
    z-index: 5
    background: rgba(255, 255, 255, 0.86)
    backdrop-filter: blur(10px)
    -webkit-backdrop-filter: blur(10px)
    border-top: 1px solid $line
    box-shadow: 0 -10px 30px rgba(11, 14, 20, 0.06)

  &__bar-inner
    max-width: 960px
    margin: 0 auto
    padding: 14px 24px
    display: flex
    align-items: center
    justify-content: space-between
    gap: 16px
    flex-wrap: wrap

  &__bar-info
    font-size: 14px
    color: $muted
    strong
      color: $ink
      font-weight: 700

  &__bar-feedback
    display: inline-flex
    align-items: center
    gap: 8px
    &--ok
      color: $green
      font-weight: 600
    &--err
      color: $red
      font-weight: 600

  &__cta
    display: inline-flex
    align-items: center
    gap: 10px
    cursor: pointer
    font-family: $display
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.06em
    font-size: 15px
    color: #fff
    background: $blue
    border: none
    border-radius: 8px
    padding: 12px 22px
    box-shadow: 0 10px 24px rgba(40, 122, 237, 0.32)
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease
    &:hover:not(:disabled)
      transform: translateY(-2px)
      box-shadow: 0 14px 30px rgba(40, 122, 237, 0.42)
    &:disabled
      cursor: not-allowed
      opacity: 0.5
      box-shadow: none
    &-ic
      font-size: 12px

// ---------- CARD DE ROBÔ ----------
.rbtcard
  display: flex
  align-items: center
  gap: 14px
  cursor: pointer
  background: $paper
  border: 1.5px solid $line
  border-radius: 14px
  padding: 14px 16px
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease
  &:hover
    transform: translateY(-3px)
    box-shadow: 0 14px 30px rgba(11, 14, 20, 0.10)
    border-color: rgba(40, 122, 237, 0.4)

  &__input
    position: absolute
    opacity: 0
    pointer-events: none

  &__check
    display: grid
    place-items: center
    flex-shrink: 0
    width: 26px
    height: 26px
    border-radius: 8px
    border: 2px solid rgba(11, 14, 20, 0.18)
    color: transparent
    font-size: 12px
    transition: all .18s ease

  &__body
    display: flex
    flex-direction: column
    gap: 2px
    min-width: 0
    flex: 1 1 auto

  &__name
    font-family: $display
    text-transform: uppercase
    font-size: 18px
    font-weight: 700
    line-height: 1.05
    color: $ink
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  &__team
    font-size: 12px
    color: $muted
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis

  &__badge
    display: inline-flex
    align-items: center
    gap: 5px
    flex-shrink: 0
    font-family: $mono
    font-size: 10px
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.04em
    color: $green
    background: rgba(46, 125, 50, 0.10)
    border: 1px solid rgba(46, 125, 50, 0.3)
    border-radius: 999px
    padding: 4px 9px
    &-ic
      font-size: 10px

  // estado selecionado
  &--on
    border-color: $blue
    background: rgba(40, 122, 237, 0.05)
    .rbtcard__check
      background: $blue
      border-color: $blue
      color: #fff

  // estado já inscrito (bloqueado)
  &--in
    cursor: default
    background: rgba(46, 125, 50, 0.04)
    border-color: rgba(46, 125, 50, 0.22)
    &:hover
      transform: none
      box-shadow: none
      border-color: rgba(46, 125, 50, 0.22)
    .rbtcard__check
      background: $green
      border-color: $green
      color: #fff

// ---------- animações ----------
@keyframes insc-rise
  from
    opacity: 0
    transform: translateY(16px)
  to
    opacity: 1
    transform: none

// ---------- responsivo ----------
@media (max-width: 620px)
  .insc__hero
    padding: 30px 0 40px
  .insc__hero-inner
    padding: 0 18px
  .insc__wrap
    padding: 32px 18px 120px
  .insc__bar-inner
    padding: 12px 18px
  .insc__cta
    flex: 1 1 100%
    justify-content: center
</style>
